import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { AbstractControl } from '@angular/forms';

@Component({
    selector: 'app-multi-select',
    templateUrl: './multi-select.component.html',
    styleUrls: ['./multi-select.component.scss']
})
export class MultiSelectComponent implements OnChanges {
    @Input()
    public control!: AbstractControl;

    @Input()
    public label?: string;

    @Input()
    public options!: Map<any, any>;

    @Input()
    public selectAll = false;

    @Input()
    public chips = true;

    @Input()
    public allOther = false;

    public keys?: any[];

    public ngOnChanges(changes: SimpleChanges): void {
        if (changes.hasOwnProperty('options')) {
            this.keys = Array.from(this.options.keys());
        }
    }

    public onClickSelectAll(): void {
        if (this.control.value?.length == this.keys!.length) {
            this.control.setValue([]);
        } else {
            this.control.setValue(Array.from(this.options.keys()));
        }
    }

    public onClickRemove(id: any): void {
        this.control.setValue((<any[]>this.control.value).filter(x => x != id));
    }
}
